/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/
import styled from '@emotion/styled';
import { style } from 'src/components/styles';

export const StyledButton = styled.button({
  boxShadow: 'none',
  transition: 'none',
  border: '0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '4px 8px',
  outline: '1px solid #585858',
  background: style.background.color.primary,
  borderRadius: style.border.radius.regular,
  textTransform: 'none',
  fontSize: style.font.size.regular,
  fontWeight: style.font.weight.regular,

  ':disabled': {
    cursor: 'auto',
    background: '#e1e5ea',
    outline: 'none',
  },
});
